import React, { useEffect, useState } from 'react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);
  return <>
      <nav className={`fixed top-0 left-0 right-0 z-50 px-6 h-[68px] flex items-center justify-between transition-all duration-300 ${scrolled ? 'bg-[rgba(8,12,20,0.96)] border-b border-[var(--border-blue)] shadow-[0_4px_30px_rgba(0,0,0,0.5)]' : 'bg-[rgba(8,12,20,0.8)] border-b border-[var(--border)]'} backdrop-blur-[20px]`} role="navigation" aria-label="Navegación principal" data-id="element-128">
        <a href="#" className="flex items-center gap-2.5 no-underline" aria-label="Oriam Marketing - inicio" data-id="element-129">
          <img src="https://cdn.magicpatterns.com/uploads/3yb7f5d7uQWjVx1ZxJha8Z/2_(2).png" alt="Oriam Marketing" className="h-8 w-auto" data-id="element-130" />
        </a>

        <ul className="hidden md:flex items-center gap-2 list-none" role="list" data-id="element-131">
          <li data-id="element-132">
            <a href="#servicios" className="no-underline text-[var(--text-muted)] text-sm font-medium px-3.5 py-1.5 rounded-md transition-all duration-[0.25s] hover:text-[var(--text)] hover:bg-[var(--surface)]" data-id="element-133">
              Qué Incluye
            </a>
          </li>
          <li data-id="element-134">
            <a href="#proceso" className="no-underline text-[var(--text-muted)] text-sm font-medium px-3.5 py-1.5 rounded-md transition-all duration-[0.25s] hover:text-[var(--text)] hover:bg-[var(--surface)]" data-id="element-135">
              Proceso
            </a>
          </li>
          <li data-id="element-136">
            <a href="#auditoria" className="no-underline text-[var(--text-muted)] text-sm font-medium px-3.5 py-1.5 rounded-md transition-all duration-[0.25s] hover:text-[var(--text)] hover:bg-[var(--surface)]" data-id="element-137">
              Análisis Gratis
            </a>
          </li>
          <li data-id="element-138">
            <a href="#testimonios" className="no-underline text-[var(--text-muted)] text-sm font-medium px-3.5 py-1.5 rounded-md transition-all duration-[0.25s] hover:text-[var(--text)] hover:bg-[var(--surface)]" data-id="element-139">
              Clientes
            </a>
          </li>
        </ul>

        <div className="hidden md:flex items-center gap-3" data-id="element-140">
          <a href="#auditoria" className="inline-flex items-center justify-center gap-2 font-bold text-sm px-5 py-2.5 rounded-xl border border-[var(--border)] bg-transparent text-[var(--text-muted)] transition-all duration-[0.25s] hover:text-[var(--text)] hover:border-[rgba(255,255,255,0.2)] hover:bg-[var(--surface)]" data-id="element-141">
            Análisis gratis
          </a>
          <a href="#contacto" className="inline-flex items-center justify-center gap-2 font-extrabold text-sm px-5 py-2.5 rounded-xl bg-[var(--neon)] text-black shadow-[0_0_0_1px_rgba(204,255,0,0.3),0_8px_24px_-4px_rgba(204,255,0,0.4),inset_0_1px_1px_rgba(255,255,255,0.4)] transition-all duration-[0.25s] hover:-translate-y-0.5 hover:shadow-[0_0_0_1px_rgba(204,255,0,0.5),0_16px_32px_-4px_rgba(204,255,0,0.5),inset_0_1px_1px_rgba(255,255,255,0.4)]" data-id="element-142">
            Empezar →
          </a>
        </div>

        <button className="md:hidden flex flex-col gap-1.5 cursor-pointer p-1.5 border-0 bg-transparent" onClick={() => setMenuOpen(!menuOpen)} aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={menuOpen} data-id="element-143">
          <span className={`block w-[22px] h-0.5 bg-[var(--text)] rounded-sm transition-all duration-[0.25s] ${menuOpen ? 'rotate-45 translate-x-[5px] translate-y-[5px]' : ''}`} data-id="element-144"></span>
          <span className={`block w-[22px] h-0.5 bg-[var(--text)] rounded-sm transition-all duration-[0.25s] ${menuOpen ? 'opacity-0 -translate-x-2.5' : ''}`} data-id="element-145"></span>
          <span className={`block w-[22px] h-0.5 bg-[var(--text)] rounded-sm transition-all duration-[0.25s] ${menuOpen ? '-rotate-45 translate-x-[5px] -translate-y-[5px]' : ''}`} data-id="element-146"></span>
        </button>
      </nav>

      <nav className={`md:hidden fixed inset-x-0 top-[68px] bottom-0 bg-[rgba(8,12,20,0.97)] backdrop-blur-[20px] z-[99] px-6 py-8 flex-col gap-2 transition-all duration-[0.25s] ${menuOpen ? 'flex opacity-100 translate-y-0' : 'hidden opacity-0 -translate-y-5'}`} role="navigation" aria-label="Menú móvil" data-id="element-147">
        <a href="#servicios" onClick={() => setMenuOpen(false)} className="no-underline text-[var(--text)] text-xl font-bold py-3.5 border-b border-[var(--border)] transition-all duration-[0.25s] hover:text-[var(--neon)] hover:pl-2" data-id="element-148">
          Qué Incluye
        </a>
        <a href="#proceso" onClick={() => setMenuOpen(false)} className="no-underline text-[var(--text)] text-xl font-bold py-3.5 border-b border-[var(--border)] transition-all duration-[0.25s] hover:text-[var(--neon)] hover:pl-2" data-id="element-149">
          Proceso
        </a>
        <a href="#auditoria" onClick={() => setMenuOpen(false)} className="no-underline text-[var(--text)] text-xl font-bold py-3.5 border-b border-[var(--border)] transition-all duration-[0.25s] hover:text-[var(--neon)] hover:pl-2" data-id="element-150">
          Análisis gratis
        </a>
        <a href="#testimonios" onClick={() => setMenuOpen(false)} className="no-underline text-[var(--text)] text-xl font-bold py-3.5 border-b border-[var(--border)] transition-all duration-[0.25s] hover:text-[var(--neon)] hover:pl-2" data-id="element-151">
          Clientes
        </a>
        <a href="#contacto" onClick={() => setMenuOpen(false)} className="inline-flex items-center justify-center gap-2 font-extrabold text-base px-8 py-4 rounded-[20px] bg-[var(--neon)] text-black shadow-[0_0_0_1px_rgba(204,255,0,0.3),0_8px_24px_-4px_rgba(204,255,0,0.4),inset_0_1px_1px_rgba(255,255,255,0.4)] mt-4 w-full" data-id="element-152">
          Empezar ahora →
        </a>
      </nav>
    </>;
}